<section class="my-2.5">
  <nav>
    <a routerLinkActive="active-link" routerLink="./casier">Changement de casier</a>
    <a routerLinkActive="active-link" routerLink="./nom">Changement de nom</a>
    <a routerLinkActive="active-link" routerLink="./fonction">Changement de fonction</a>
  </nav>
</section>
<router-outlet></router-outlet>

<p style="text-align: center;">* <span style="font-weight: bold;">Les demandes de ce menu ne modifieront pas la dotation de l'utilisateur.</span><br>
  Si vous devez modifier la dotation merci d'utiliser le menu <a routerLink="../dotation">Dotation</a> et utilisez la zone commentaire si besoin.</p>
